export const environment = {
  production: true,
  VERSION: require('package.json').version,
  hrefBase: "",
};
